import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectOutletComponent } from './select-outlet.component';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderModule } from '../../app-shared/components/loader/loader.module';
import { MatButtonModule } from '@angular/material/button';
import { SelectOutletRoutingModule } from './select-outlet-routing.module';

@NgModule({
  declarations: [SelectOutletComponent],
  imports: [
    CommonModule,
    SelectOutletRoutingModule,
    TranslateModule,
    LoaderModule,
    MatButtonModule,
  ],
  exports: [SelectOutletComponent],
})
export class SelectOutletModule {}
